import { StepConnector } from '@mui/material';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../theme';

export const StyledProgressBarContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        background-color: ${theme.palette.common.white};
        border-bottom: ${theme.tggSpacing(rem(0.1), 0.25)} solid ${theme.palette.grey[200]};
    `}
`;

export const StyledStep = styled(Step)``;

export const StyledStepper = styled(Stepper)`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing([rem(1), rem(2.1)], [2.5, 5.25])};
        margin: ${theme.tggSpacing('auto', 'auto')};
        background-color: ${theme.palette.common.white};

        ${theme.breakpoints.up('desktop')} {
            width: 100%;
            max-width: ${theme.tggSpacing(rem(98), 245)};
        }
    `}
`;

export const StyledStepLabel = styled(StepLabel)`
    ${({ theme }: { theme: Theme }) => `
        text-transform: lowercase;

        &.Mui-disabled {
            svg {
                opacity: 50%;
            }
        }

        & .MuiStepLabel-label.MuiStepLabel-alternativeLabel {
            margin-top: ${theme.tggSpacing(0, 0)};
        }

        a {
            color: inherit;
            text-decoration: inherit;
        }
    `}

    & .MuiStepLabel-label {
        ${({ theme }: { theme: Theme }) => `
            margin-top: ${theme.tggSpacing(0, 0)};
	    `}

        ${({ theme }: { theme: Theme }) => theme.typography.bodyXXSmall};
    }
`;

export const StyledStepConnector = styled(StepConnector)`
    ${({ theme }: { theme: Theme }) => `
        &.MuiStepConnector-alternativeLabel {
            top: ${theme.tggSpacing(rem(1), 2.5)};
            right: calc(50% + ${theme.tggSpacing(rem(3), 7.5)});
            left: calc(-50% + ${theme.tggSpacing(rem(3), 7.5)});
            ${theme.breakpoints.up('desktop')} {
                top: ${theme.tggSpacing(rem(1.6), 4)};
            }
        }

        & .MuiStepConnector-lineHorizontal {
            border-color: ${theme.palette.grey[200]};
            border-radius: ${theme.tggSpacing(rem(0.05), 0.125)};
        }

        &.MuiStepConnector-active {
            & .MuiStepConnector-lineHorizontal {
                border-color: ${theme.palette.primary.main};
            }
        }

        &.MuiStepConnector-completed {
            & .MuiStepConnector-lineHorizontal {
                border-color: ${theme.palette.primary.main};
            }
        }
    `}
`;

export const StyledLabelContent = styled('span')<{
    $isActive?: boolean;
}>`
    ${({ $isActive, theme }: { $isActive?: boolean; theme: Theme }) =>
        $isActive && theme.typography.heading_10_lh_16};
`;
